import {Component, ElementRef, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {LandingPageService} from '../../../../services/landing-page.service';
import {Globals} from '../../../../globals';
import {PatientCaseViewDataModel} from '../../../../models/patient/patient-case-view-data.model';
import {FileManagerService} from '../../../../modules/file-manager/file-manager.service';
import {DocumentInFolderDataModel} from '../../../../models/document/document-in-folder-data.model';
import {DocumentGetCaseTeethModel} from '../../../../models/document/document-get-case-teeth.model';
import {ToothConfigurationModel} from '../../../../models/teeth/tooth-configuration.model';
import {MatCheckbox, MatCheckboxChange} from '@angular/material/checkbox';
import {DataPatientCaseWorkItemToothModel} from '../../../../models/teeth/data-patient-case-work-item-tooth.model';
import {DocumentPseudoPatientCaseWorkItemToothDataModel} from '../../../../models/document/document-pseudo-patient-case-work-item-tooth-data.model';
import {DocumentSaveCaseTeethModel, SelectedCaseWorkItemTeeth} from '../../../../models/document/document-save-case-teeth.model';

@Component({
  selector: 'app-tdo-organizer-case-tooth-dialog',
  templateUrl: './tdo-organizer-case-tooth-dialog.component.html',
  styleUrls: ['./tdo-organizer-case-tooth-dialog.component.scss']
})
export class TdoOrganizerCaseToothDialogComponent implements OnInit {
  cases: PatientCaseViewDataModel[] = [];
  selectedCase: PatientCaseViewDataModel;
  currentCaseAndTeeth: DocumentGetCaseTeethModel;
  selectedConfigurationTeeth: ToothConfigurationModel[] = [];
  selectedCaseWorkItemTeeth: DataPatientCaseWorkItemToothModel[] = [];
  selectedCaseWorkItemTeethIds: SelectedCaseWorkItemTeeth[] = [];

  constructor(private dialogRef: MatDialogRef<TdoOrganizerCaseToothDialogComponent>,
              private el: ElementRef,
              @Inject(MAT_DIALOG_DATA) private data: DocumentInFolderDataModel,
              private fileManagerService: FileManagerService,
              private globals: Globals,
              private landingPageService: LandingPageService) { }

  ngOnInit(): void {
    this.landingPageService.getPatientsCases4Landing(this.globals.currentPatientId).subscribe((res) => {
      this.cases = res;

      this.fileManagerService.getCaseTeethForDocument(this.data.dataDocument).subscribe((res1) => {
        this.currentCaseAndTeeth = res1;
        this.selectedCaseWorkItemTeethIds.push(...this.currentCaseAndTeeth.teeth.map(p => ({ selectedCaseWorkItemTeethId: p.CaseWorkItemToothId, ToothID: p.ToothID })));
        this.selectedConfigurationTeeth = this.globals.teeth.filter(p => this.currentCaseAndTeeth.teeth.map(g => g.ToothID).includes(p.ToothId));
        const cse = this.cases.find(p => p.PatientCaseId === res1.patientCaseId);
        if (cse) {
          this.selectedCase = cse;
          this.selectedCase.TeethConfigurations = this.globals.teeth.filter(p => this.selectedCase.TeethIdsList.includes(p.ToothId));
          setTimeout(() => {
            this.el.nativeElement.querySelector('.case-tooth-dialog-item-selected').scrollIntoView();
          }, 200);
        }
      });
    });
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }

  onOkClick() {
    const model = new DocumentSaveCaseTeethModel();
    model.documentId = this.data.dataDocument.DocumentID;
    model.patientId = this.data.dataDocument.PatientId;
    model.parentDocumentId = this.data.dataDocument.ParentDocumentID;
    model.oldPatientCaseId = this.currentCaseAndTeeth.patientCaseId;
    model.newPatientCaseId = this.selectedCase.PatientCaseId;
    model.selectedCaseWorkItemTeeth = this.selectedCaseWorkItemTeethIds;
    this.fileManagerService.saveCaseTooth(model).subscribe((res) => {
      this.dialogRef.close(true);
    });
  }

  onCaseClick(cse: PatientCaseViewDataModel) {// when case lenght = 1 but not original included to new one
    this.selectedCase = cse;
    this.selectedCaseWorkItemTeethIds = [];
    // If selecting through the list, you land on the documents current case, auto select the teeth, otherwise blank it out.
    if (this.selectedCase.PatientCaseId === this.currentCaseAndTeeth.patientCaseId) {
      // this.selectedCaseWorkItemTeethIds = this.currentCaseAndTeeth.teeth.map(p => p.CaseWorkItemToothId);
      this.selectedCaseWorkItemTeethIds.push(...this.currentCaseAndTeeth.teeth.map(p => ({ selectedCaseWorkItemTeethId: p.CaseWorkItemToothId, ToothID: p.ToothID })));
    } else if (this.selectedCase.TeethList.length === 1) {
      this.selectedCaseWorkItemTeethIds = cse.DataTeethIdsList.map(p => ({ selectedCaseWorkItemTeethId: p.CaseWorkItemToothId, ToothID: p.ToothID }));
    }
  }

  onCheckboxChange($event: MatCheckboxChange, tooth: DocumentPseudoPatientCaseWorkItemToothDataModel, cb: MatCheckbox) {
    if ($event.checked) {
      if (!this.selectedCaseWorkItemTeethIds.find(x=> x.ToothID ===  tooth.ToothID)) {
        const selectedTooth = new SelectedCaseWorkItemTeeth();
        selectedTooth.selectedCaseWorkItemTeethId = tooth.CaseWorkItemToothId;
        selectedTooth.ToothID = tooth.ToothID;
        this.selectedCaseWorkItemTeethIds.push(selectedTooth);
      }
    } else {
      if (this.selectedCaseWorkItemTeethIds.find(x=> x.ToothID ===  tooth.ToothID)) {
        this.selectedCaseWorkItemTeethIds = this.selectedCaseWorkItemTeethIds.filter(x => x.ToothID !== tooth.ToothID);
      }
    }
  }

  isChecked(tooth: DocumentPseudoPatientCaseWorkItemToothDataModel) {
    if (this.selectedCase.DataTeethIdsList.length === 1 || this.selectedCaseWorkItemTeethIds.find(x => x.ToothID === tooth.ToothID)) {
      return true;
    }
    return false;
  }
}
